import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinema%20hallway%20with%20film%20posters%20in%20golden%20frames%2C%20soft%20red%20carpet%2C%20ambient%20warm%20lighting%2C%20elegant%20movie%20theater%20interior%20with%20art%20deco%20details&width=1800&height=600&seq=cta-bg-cinema-2025&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 font-heading">
          准备好开始观影了吗？
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-[500px] mx-auto leading-relaxed">
          海量影视资源、高清流畅播放、完全免费观看。立即加入91免费，畅享无限观影乐趣！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
          >
            开始免费观影
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap text-center border border-white/20"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}